import AxiosConfig from '@/config/axios-config'

export const PublicoAlvoAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/publico-alvo',
      {
      }).then(response => response.data.data)
  },

  salvar (publicoAlvo) {
    return AxiosConfig.secureJalekoAPI().post('/admin/publico-alvo', publicoAlvo).then(response => response)
  },

  deletar (publicoAlvo) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/publico-alvo/${publicoAlvo.id}`, publicoAlvo).then(response => response.data)
  }

}

export default PublicoAlvoAPI
